import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./dsaTable";
import WGRTotals from "./dsaTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
    return rows.reduce(
      (sum, row) => ({
        debit:
          sum.debit +
          Number(row.DEBIT || 0),

        credit:
          sum.credit +
          Number(row.CREDIT || 0),
        
      }),
      {
        debit: 0,
        credit: 0,
        
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          
        >
          DEPOT CODE : {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

